module.exports = __webpack_public_path__ + "img/image1.55af144c.jpg";